import { render, staticRenderFns } from "./ProdutoColumn.vue?vue&type=template&id=1e8b02c8&scoped=true&"
import script from "./ProdutoColumn.vue?vue&type=script&lang=js&"
export * from "./ProdutoColumn.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoColumn.vue?vue&type=style&index=0&id=1e8b02c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b02c8",
  null
  
)

export default component.exports